import React from "react";
import { Outlet, generatePath, useParams } from "react-router-dom";
import { LinkTabs } from "../framework/linkTabs";
import { useTranslation } from "react-i18next";
import { useAppOptionValueEquals } from "../../hooks/framework/useAppOptionValue";
import { optionOwnerHasCustomWorkTimeAllowed } from "../../models/common/consts";
import { LoadingIndicator } from "../framework/loadingIndicator";
import { useAppSelector } from "../../framework/redux/hooks";

export const WorkTimeFormTabs = () => {
    const { t } = useTranslation();
    const { date } = useParams();
    const [customTypeEnabled, optionLoading] = useAppOptionValueEquals(
        optionOwnerHasCustomWorkTimeAllowed,
        "1"
    );
    const canAddAndEditDayBookings = useAppSelector(
        ({ session }) => session.employeeGroupParameters?.canAddAndEditDayBookings
    );

    if (optionLoading) return <LoadingIndicator />;

    return (
        <LinkTabs
            tabs={[
                {
                    value: "worktime",
                    label: t("workTime.workTimeEntry"),
                    matchPaths: ["/work/form/new/*", "/work/form/edit/*"],
                    to: generatePath("/work/form/new/:date?", { date }),
                    children: <Outlet />,
                },
                customTypeEnabled
                    ? {
                        value: "other",
                        label: t("workTime.customTypeLabel"),
                        matchPaths: [
                            "/work/form/other/new/*",
                            "/work/form/other/edit/*",
                        ],
                        to: generatePath("/work/form/other/new/:date?", {
                            date,
                        }),
                        children: <Outlet />,
                    }
                    : null,
                canAddAndEditDayBookings
                    ? {
                        value: "daybooking",
                        label: t("dayBooking.dayBooking"),
                        matchPaths: ["/work/form/daybooking/*"],
                        to: generatePath("/work/form/daybooking/new/:date?", {
                            date,
                        }),
                        children: <Outlet />,
                    }
                    : null,
            ].filter(Boolean)}
        />
    );
};
